import LanguageUtility from '../../utility/language-utility';

/**
 * Helper for getting translated labels.
 *
 * @param {string} key Key of the label to get
 * @param {object} options Helper options
 * @param {string} [options.label] Return this string unless it is empty; if empty, translate the given key
 * @returns {string} Translated label
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default function (key: string, options: any): string {
  if (options.hash.hasOwnProperty('label') && options.hash.label) {
    return options.hash.label;
  }
  return LanguageUtility.getLabel(key);
}
